import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";
import {
  OWNER_SCOPE_STORAGE_KEY,
  isValidOwnerScope,
  parseOwnerScope,
} from "../utils/ownerScope";

export { OWNER_SCOPE_VALUES } from "../utils/ownerScope";

const OwnerScopeContext = createContext();

export const OwnerScopeProvider = ({ children }) => {
  const [ownerScope, setOwnerScopeState] = useState(() => {
    const stored = localStorage.getItem(OWNER_SCOPE_STORAGE_KEY);
    if (stored && isValidOwnerScope(stored)) {
      return stored;
    }
    // null = "not yet resolved". CSMScopeFilter's resolveEffectiveScope
    // will set the role-appropriate default (MINE for CSMs, ALL for admins)
    // once auth + team settings load.
    return null;
  });

  const setOwnerScope = useCallback((value) => {
    if (!isValidOwnerScope(value)) {
      return;
    }
    setOwnerScopeState(value);
    localStorage.setItem(OWNER_SCOPE_STORAGE_KEY, value);
    window.dispatchEvent(
      new CustomEvent("ownerScopeChanged", { detail: value }),
    );
  }, []);

  const { mode, csOwnerId } = useMemo(
    () => parseOwnerScope(ownerScope),
    [ownerScope],
  );

  return (
    <OwnerScopeContext.Provider
      value={{ ownerScope, setOwnerScope, mode, csOwnerId }}
    >
      {children}
    </OwnerScopeContext.Provider>
  );
};

export const useOwnerScopeContext = () => {
  const context = useContext(OwnerScopeContext);
  if (!context) {
    throw new Error(
      "useOwnerScopeContext must be used within an OwnerScopeProvider",
    );
  }
  return context;
};
